import React from "react";
import { Button } from "@headlessui/react";

const CustomButton = ({
  onClick,
  color = "gray",
  icon: Icon,
  text,
  flip = false,
  disabled = false,
}) => {
  const colors = {
    red: {
      light: "bg-red-600",
      dark: "bg-red-700",
      ring: "ring-red-600/30",
    },
    green: {
      light: "bg-green-600",
      dark: "bg-green-700",
      ring: "ring-green-600/30",
    },
    blue: {
      light: "bg-blue-600",
      dark: "bg-blue-700",
      ring: "ring-blue-600/30",
    },
    orange: {
      light: "bg-orange-600",
      dark: "bg-orange-700",
      ring: "ring-orange-600/30",
    },
    gray: {
      light: "bg-gray-600",
      dark: "bg-gray-700",
      ring: "ring-gray-500/30",
    },
  };

  const c = colors[color] || colors.gray;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`
        group inline-flex items-stretch overflow-hidden
        rounded-md text-xs font-semibold tracking-wide text-white
        transition-all duration-200 ease-out
        ring-1 ring-inset ${c.ring}
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:scale-[1.04] active:scale-[0.97]"}
      `}
    >
      {/* Icon on LEFT (default) */}
      {Icon && !flip && (
        <div
          className={`
            flex items-center justify-center px-1.5
            ${c.dark}
            transition-all duration-200
            ${disabled ? "" : "group-hover:brightness-110"}
          `}
        >
          <Icon className="size-4 transition-transform duration-200 group-hover:-translate-x-0.5" />
        </div>
      )}

      {/* Label side */}
      <div
        className={`
          flex items-center gap-1.5 px-2 py-1.5
          ${c.light}
          transition-all duration-200
          ${disabled ? "" : "group-hover:brightness-105"} whitespace-nowrap
        `}
      >
        <span
          className={`
            transition-transform duration-200
            ${flip ? "group-hover:-translate-x-0.5" : "group-hover:translate-x-0.5"}
          `}
        >
          {text}
        </span>
      </div>

      {/* Icon on RIGHT when flip=true */}
      {Icon && flip && (
        <div
          className={`
            flex items-center justify-center px-1.5
            ${c.dark}
            transition-all duration-200
            ${disabled ? "" : "group-hover:brightness-110"}
          `}
        >
          <Icon className="size-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      )}
    </Button>
  );
};

export default CustomButton;
